import LegalLayout, { LegalSection } from "@/components/pages/LegalLayout";

const PrivacyPolicy = () => {
  return (
    <LegalLayout
      title="Privacy Policy — OrderHalal.ai"
      effectiveDate="August 1, 2026"
      metaDescription="How OrderHalal.ai handles personal information collected through our website, inquiry forms, and AI voice agent services."
    >
      <LegalSection heading="1. Introduction">
        <p>
          This Privacy Policy explains how OrderHalal.ai ("we," "us," "our"), a Texas-based sole
          proprietorship, handles personal information collected through our website, inquiry forms,
          and AI voice agent services. By visiting our website, submitting an inquiry, booking a
          demo, or engaging our services, you agree to this Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection heading="2. Information We Collect">
        <p>
          We collect information you provide directly, such as your name, business name, phone
          number, email address, and any message you submit through our inquiry form or demo booking
          page. If you become a client, we may also collect call data and voice recordings processed
          through our AI voice agent services on your behalf.
        </p>
      </LegalSection>

      <LegalSection heading="3. How We Use Your Information">
        <p>We use your information to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Respond to inquiries and schedule demos</li>
          <li>Provide, operate, and support our AI voice agent services for clients</li>
          <li>Improve our services</li>
          <li>Communicate with you about your account or service, if you become a client</li>
        </ul>
        <p>We do not sell your personal information to third parties.</p>
      </LegalSection>

      <LegalSection heading="4. AI Voice Agent Services">
        <p>
          For clients, our service processes phone calls through AI voice technology, which may
          involve recording and transcribing calls placed to your business's line for the purpose of
          assisting callers and completing tasks such as taking orders, scheduling, or answering
          questions, depending on the service configured for your business. Clients are responsible
          for ensuring their customers receive any legally required notice regarding call recording
          or AI-assisted interactions, consistent with applicable state and federal law.
        </p>
      </LegalSection>

      <LegalSection heading="5. Sharing of Information">
        <p>
          We may share information with service providers who help us operate our business (such as
          scheduling, hosting, and communication tools), or as required by law. We do not share your
          information for third-party marketing purposes.
        </p>
      </LegalSection>

      <LegalSection heading="6. Data Retention">
        <p>
          We retain personal information for as long as reasonably necessary to respond to your
          inquiry, provide services, or comply with legal obligations. You may request deletion of
          your information at any time by contacting us (see Section 8).
        </p>
      </LegalSection>

      <LegalSection heading="7. Your Rights">
        <p>
          You may request access to, correction of, or deletion of your personal information by
          contacting us at the email below. We will respond within a reasonable timeframe.
        </p>
      </LegalSection>

      <LegalSection heading="8. Contact Us">
        <p>
          OrderHalal.ai
          <br />
          Richardson, Texas
          <br />
          <a href="mailto:contact@orderhalal.ai" className="text-terra hover:underline">
            contact@orderhalal.ai
          </a>
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Changes will be posted on this page
          with a revised effective date.
        </p>
      </LegalSection>

      <hr className="border-line" />
      <p className="text-sm text-sand/60 italic leading-relaxed">
        This document is a general privacy notice for a small, pre-formation business and has not
        been reviewed by an attorney. It should be reviewed by a licensed attorney before relying on
        it for a business handling significant volumes of client or consumer data.
      </p>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
